export enum SegmentsSwitcherEnum {
  Customized = 'customized',
  EmBlueRecipes = 'emBlueRecipes',
  ECommerce = 'eCommerce',
}
